// extracted by mini-css-extract-plugin
export default {"zoomModal":"D1-z"};